import { useIngestionRules } from "@/shared/domain/ingestionRules/hooks";

/** Why a rule-owned trigger cannot be changed here. */
export function managedByRuleExplanation(ruleName: string | null): string {
  const rule =
    ruleName === null
      ? "an ingestion rule"
      : `the ingestion rule "${ruleName}"`;
  return `This trigger is managed by ${rule}. Change it through the rule: turning auto-ingest off on the rule turns this trigger off, and turning it back on turns it on again.`;
}

/** The name of the rule with this id, once the org's rules have loaded. */
export function useIngestionRuleName(ruleId: string): string | null {
  const rules = useIngestionRules();
  return rules.data?.find((rule) => rule.rule_id === ruleId)?.name ?? null;
}
